import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Header from "./header";
import AdminControl from "./pages/AdminControl";
import AddProduct from "./pages/AddProduct";
import ViewProduct from "./pages/ViewProduct";
import EditProduct from "./pages/EditProduct";
import AllList from "./pages/AllList";
import SoldList from "./pages/SoldList";
import AddType from "./pages/AddType";
import TypeList from "./pages/TypeList";
import AddSubtype from "./pages/AddSubtype";
import SubtypeList from "./pages/SubtypeList";
import AddLicense from "./pages/AddLicense";
import LicenseList from "./pages/LicenseList";
import AddLanguage from "./pages/AddLanguage";
import LanguageList from "./pages/LanguageList";
import AddPackaging from "./pages/AddPackaging";
import PackagingList from "./pages/PackagingList";
import EditPackaging from "./pages/EditPackaging";
import AddLinkType from "./pages/AddLinkType";
import LinkTypeList from "./pages/LinkTypeList";
import AddRarityCard from "./pages/AddRarityCard";
import RarityList from "./pages/RarityCardList";
import AddCollection from "./pages/AddCollection";
import CollectionList from "./pages/CollectionList";
import AddExtension from "./pages/AddExtension";
import ExtensionList from "./pages/ExtensionList";
import AddUnityCard from "./pages/AddUnityCard";
import UnityCardList from "./pages/UnityCardList";
import ViewUnityCard from "./pages/ViewUnityCard";
import EditUnityCard from "./pages/EditUnityCard";
import SoldUnityCard from "./pages/SoldUnityCard";
import AddUser from "./pages/AddUser";
import UserList from "./pages/UserList";

function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1 bg-white text-black dark:bg-gray-800 dark:text-white p-4">
          <Routes>
            <Route path="*" element={<Home />} />
            <Route path="/admin" element={<AdminControl />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/product/:id" element={<ViewProduct />} />
            <Route path="/edit-product/:id" element={<EditProduct />} />
            <Route path="/all-list" element={<AllList />} />
            <Route path="/sold-list" element={<SoldList />} />
            <Route path="/add-unity_card" element={<AddUnityCard />} />
            <Route path="/unity_card/:id" element={<ViewUnityCard />} />
            <Route path="/edit-unity-card/:id" element={<EditUnityCard />} />
            <Route path="/unity_card-list" element={<UnityCardList />} />
            <Route path="/sold-unity_card" element={<SoldUnityCard />} />
            <Route path="/add-type" element={<AddType />} />
            <Route path="/type-list" element={<TypeList />} />
            <Route path="/add-subtype" element={<AddSubtype />} />
            <Route path="/subtype-list" element={<SubtypeList />} />
            <Route path="/add-license" element={<AddLicense />} />
            <Route path="/license-list" element={<LicenseList />} />
            <Route path="/add-language" element={<AddLanguage />} />
            <Route path="/language-list" element={<LanguageList />} />
            <Route path="/add-packaging" element={<AddPackaging />} />
            <Route path="/packaging-list" element={<PackagingList />} />
            <Route path="/edit-packaging/:id" element={<EditPackaging />} />
            <Route path="/add-linktype" element={<AddLinkType />} />
            <Route path="/linktype-list" element={<LinkTypeList />} />
            <Route path="/add-rarity_card" element={<AddRarityCard />} />
            <Route path="/rarity_card-list" element={<RarityList />} />
            <Route path="/add-collection" element={<AddCollection />} />
            <Route path="/collection-list" element={<CollectionList />} />
            <Route path="/add-extension" element={<AddExtension />} />
            <Route path="/extension-list" element={<ExtensionList />} />
            <Route path="/add-user" element={<AddUser />} />
            <Route path="/user-list" element={<UserList />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
